import { useEffect, useState } from 'react';

const CLIENT_ID = '23011090332-833udguq191tphc77ud5hj0q28k3ln2i.apps.googleusercontent.com';
const SCOPES = 'https://www.googleapis.com/auth/spreadsheets https://www.googleapis.com/auth/drive.file';
const DISCOVERY_DOCS = [
	'https://sheets.googleapis.com/$discovery/rest?version=v4',
	'https://www.googleapis.com/discovery/v1/apis/drive/v3/rest',
];

const loadScriptFile = (scriptSrc: string) => {
	return new Promise((resolve, reject) => {
		const script = document.createElement('script');
		script.type = 'text/javascript';
		script.src = scriptSrc;
		script.onload = resolve;
		script.onerror = reject;
		document.body.appendChild(script);
	});
};

export const useGoogleAPI = () => {
	const [tokenClient, setTokenClient] = useState<any>(null);

	useEffect(() => {
		// https://developers.google.com/identity/oauth2/web/guides/migration-to-gis#gapi-asyncawait
		const init = async () => {
			// Load and init gapi
			await loadScriptFile('https://apis.google.com/js/api.js');
			await new Promise((resolve, reject) => {
				gapi.load('client', { callback: resolve, onerror: reject });
			});
			await gapi.client.init({}).then(() => {
				DISCOVERY_DOCS.forEach((doc) => {
					gapi.client.load(doc);
				});
			});

			// Load and init gis
			await loadScriptFile('https://accounts.google.com/gsi/client');
			await new Promise((resolve, reject) => {
				try {
					const newTokenClient = google.accounts.oauth2.initTokenClient({
						client_id: CLIENT_ID,
						scope: SCOPES,
						prompt: 'consent',
						// @ts-expect-error works as is
						callback: '', // defined at request time in await/promise scope.
					});
					resolve(null);
					setTokenClient(newTokenClient);
				} catch (err) {
					reject(err);
				}
			});
		};

		init();
	}, []);

	async function getToken(err?: any) {
		if (
			!err ||
			err.result.error.code == 401 ||
			(err.result.error.code == 403 && err.result.error.status == 'PERMISSION_DENIED')
		) {
			// The access token is missing, invalid, or expired, prompt for user consent to obtain one.
			await new Promise((resolve, reject) => {
				try {
					// Settle this promise in the response callback for requestAccessToken()
					tokenClient.callback = (resp: any) => {
						if (resp.error !== undefined) {
							reject(resp);
						}
						// GIS has automatically updated gapi.client with the newly issued access token.
						resolve(resp);
					};
					tokenClient.requestAccessToken();
				} catch (err) {
					console.log(err);
				}
			});
		} else {
			// Errors unrelated to authorization: server errors, exceeding quota, bad requests, and so on.
			throw new Error(err);
		}
	}

	return { getToken };
};
